<template>
  <v-container>
      <v-col cols="12">
        <v-row justify="center" class="mt-3">
          <h1>
            Новая анкета
          </h1>
        </v-row>
      </v-col>
        <v-col
            cols="12"
        >
          <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="имя"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.name"
                    :error-messages="errors"
                    label="Имя"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="предоставленная услуга"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.serviceProvided"
                    :error-messages="errors"
                    :items="serviceProviders"
                    label="Предоставленная услуга"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="обращение"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.primacy"
                    :error-messages="errors"
                    :items="primacyTypes"
                    label="Обращение"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="кто обратился"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.whoCalled"
                    :error-messages="errors"
                    label="Кто обратился?"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="пол"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.gender"
                    :error-messages="errors"
                    :items="['муж', 'жен']"
                    label="Пол"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="возраст"
                  rules="required|numeric|max:120"
              >
                <v-text-field
                    v-model="questionnaires.age"
                    :error-messages="errors"
                    label="Возраст"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="семейное положение"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.maritalStatus"
                    :error-messages="errors"
                    :items="maritalStatuses"
                    label="Семейное положение"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="национальность"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.nationality"
                    :error-messages="errors"
                    :items="nationalities"
                    label="Национальность"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="образование"
                  rules="required"
              >
                <v-select
                  v-model="questionnaires.education"
                  :error-messages="errors"
                  :items="educations"
                  label="Образование"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="социальный статус"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.socialStatus"
                    :error-messages="errors"
                    :items="socialStatuses"
                    label="Социальный статус"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="место рождения"
                  rules="required"
              >
                <v-select
                  v-model="questionnaires.placeOfBirthType"
                  :error-messages="errors"
                  :items="placeOfBirthTypes"
                  label="Место рождения (Тип населенного пункта)"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                v-if="questionnaires.placeOfBirthType === placeOfBirthTypes[0] || questionnaires.placeOfBirthType === placeOfBirthTypes[1]"
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="место рождения"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.placeOfBirth"
                    :error-messages="errors"
                    label="Место рождения (Название насленного пункта)"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="причина обращения"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.petitionReason"
                    :error-messages="errors"
                    :items="petitionReasons"
                    label="Причина обращения"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                v-if="questionnaires.petitionReason === petitionReasons[5].value"
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="причина обращения"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.petitionReasonOther"
                    :error-messages="errors"
                    label="Причина обращения (Если выбрано другое)"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                v-if="questionnaires.petitionReason === petitionReasons[3].value"
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="торговля людьми"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.humanTraffickingType"
                    :error-messages="errors"
                    :items="humanTraffickingTypes"
                    label="Торговля людьми (Тип)"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row
              v-if="questionnaires.petitionReason === petitionReasons[0].value"
          >
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="Домашнее насилие"
                  rules="required"
              >
                <v-select
                    v-model="questionnaires.domesticViolenceType"
                    :error-messages="errors"
                    :items="domesticViolenceTypes"
                    label="Домашнее насилие (Выберите другое если нет в списке)"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col
                v-if="questionnaires.domesticViolenceType === domesticViolenceTypes[5].value"
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="Домашнее насилие"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.domesticViolenceOther"
                    :error-messages="errors"
                    label="Домашнее насилие (Если выбрано другое)"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-textarea
              v-model="questionnaires.description"
              label="Описание проблемы"
          ></v-textarea>

          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <v-checkbox
                  v-model="questionnaires.asylum"
                  label="Предоставлено убежище"
              ></v-checkbox>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <v-checkbox
                  v-model="questionnaires.hotLine"
                  label="Оказана помощь по телефону"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="как нас нашли"
                  rules="required|max:120"
              >
                <v-text-field
                    v-model="questionnaires.howFind"
                    :error-messages="errors"
                    label="Как нас нашли?"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col
                sm="6"
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="Создано"
                  rules="required"
              >
                <v-menu
                    ref="createdAtMenu"
                    v-model="createdAtMenu"
                    :close-on-content-click="true"
                    :return-value.sync="questionnaires.createdAt"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="questionnaires.createdAt"
                        label="Создано"
                        prepend-icon="mdi-calendar"
                        :error-messages="errors"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="questionnaires.createdAt"
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      :min="moment().add(-14, 'days').format('YYYY-MM-DD')"
                      no-title
                      scrollable
                      @change="$refs.createdAtMenu.save(questionnaires.createdAt)"
                  ></v-date-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn
                color="primary"
                @click.prevent="handleSubmit(save)"
                :disabled="disabled"
            >
              Сохранить
            </v-btn>
          </v-row>
          </ValidationObserver>
        </v-col>
  </v-container>
</template>

<script>
import moment from 'moment'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import serviceProviders from '../enum/serviceProvided'
import primacyTypes from '../enum/primacyTypes'
import maritalStatuses from '../enum/maritalStatuses'
import nationalities from '../enum/nationalities'
import educations from '@/enum/educations'
import socialStatuses from '@/enum/socialStatuses'
import placeOfBirthTypes from '@/enum/placeOfBirthTypes'
import petitionReasons from '@/enum/petitionReasons'
import humanTraffickingTypes from '@/enum/humanTraffickingTypes'
import domesticViolenceTypes from '../enum/domesticViolenceTypes'
import { mapGetters } from "vuex";
import specializations from "@/enum/specializations";

export default {
  name: 'Main',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      questionnaires: {
        serviceProvided: '',
        primacy: '',
        whoCalled: 'Сам клиент',
        name: '',
        gender: '',
        age: '',
        maritalStatus: '',
        nationality: '',
        education: '',
        socialStatus: '',
        placeOfBirthType: '',
        placeOfBirth: '',
        petitionReason: '',
        petitionReasonOther: '',
        humanTraffickingType: '',
        domesticViolenceType: '',
        domesticViolenceOther: '',
        description: '',
        hotLine: false,
        asylum: false,
        howFind: '',
        createdAt: moment().format('YYYY-MM-DD'),
      },
      moment: moment,
      createdAtMenu: false,
      serviceProviders: serviceProviders,
      primacyTypes: primacyTypes,
      maritalStatuses: maritalStatuses,
      nationalities: nationalities,
      educations: educations,
      socialStatuses: socialStatuses,
      placeOfBirthTypes: placeOfBirthTypes,
      petitionReasons: petitionReasons,
      humanTraffickingTypes: humanTraffickingTypes,
      domesticViolenceTypes: domesticViolenceTypes,
      disabled: false,
    }
  },
  computed: {
    ...mapGetters({
      getSpecialization: 'security/getSpecialization',
    })
  },
  mounted() {
    this.questionnaires.serviceProvided = this.serviceProvidedDefault()
  },
  methods: {
    async save() {
      this.disabled = true
      const timeoutId = setTimeout( () => {
        this.$toasted.error('Что-то пошло не так. Попробуйте еще раз сохранить')
        this.disabled = false
      }, 10000)
      try {
        await this.$store.dispatch('questionnaires/create', this.questionnaires)
        this.$toasted.success('Успешно сохранено')
        this.clear()
      } catch (err) {
        this.$toasted.error('Что-то пошло не так')
      }
      this.disabled = false
      clearTimeout(timeoutId);
    },
    clear() {
      this.questionnaires.primacy = '';
      this.questionnaires.whoCalled = 'Сам клиент';
      this.questionnaires.name = '';
      this.questionnaires.gender = '';
      this.questionnaires.age = '';
      this.questionnaires.maritalStatus = '';
      this.questionnaires.nationality = '';
      this.questionnaires.education = '';
      this.questionnaires.socialStatus = '';
      this.questionnaires.placeOfBirthType = '';
      this.questionnaires.placeOfBirth = '';
      this.questionnaires.petitionReason = '';
      this.questionnaires.petitionReasonOther = '';
      this.questionnaires.humanTraffickingType = '';
      this.questionnaires.domesticViolenceType = '';
      this.questionnaires.description = '';
      this.questionnaires.hotLine = false;
      this.questionnaires.asylum = false;
      this.questionnaires.howFind = '';
      this.questionnaires.domesticViolenceOther = '';
      this.questionnaires.domesticViolenceOther = '';
      this.$refs.validationObserver.reset()
    },
    serviceProvidedDefault() {
      if (this.getSpecialization === specializations[0] || this.getSpecialization === specializations[1]) {
        return this.serviceProviders[3]
      }
      if (this.getSpecialization === specializations[2] || this.getSpecialization === specializations[3]) {
        return this.serviceProviders[0]
      }
      if (this.getSpecialization === specializations[4]) {
        return this.serviceProviders[1]
      }
      if (this.getSpecialization === specializations[5] || this.getSpecialization === specializations[6]) {
        return this.serviceProviders[2]
      }
    }
  }
}
</script>

<style scoped>

</style>
